
import React, { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import ForexHeader from "./ForexHeader";
import ForexBottomNav from "../Components/ForexBottomNav";
import "./ForexHistory.css";

const ForexHistory = () => {
  const username = localStorage.getItem("username")?.trim() || "";

  const [trades, setTrades] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!username) {
      setTrades([]);
      setLoading(false);
      return undefined;
    }

    setLoading(true);

    const historyQuery = query(
      collection(db, "Forex"),
      where("username", "==", username)
    );

    const unsubscribe = onSnapshot(
      historyQuery,
      (snapshot) => {
        const closedTrades = snapshot.docs
          .map((item) => ({
            id: item.id,
            ...item.data(),
          }))
          .filter(
            (trade) =>
              trade.status === "closed" ||
              trade.closed === true ||
              trade.status === "expired" ||
              trade.status === "cancelled"
          )
          .sort((a, b) => {
            const getTime = (trade) =>
              trade.closedAt?.toMillis?.() ||
              trade.expiredAt?.toMillis?.() ||
              trade.createdAt?.toMillis?.() ||
              0;

            return getTime(b) - getTime(a);
          });

        setTrades(closedTrades);
        setLoading(false);
      },
      (error) => {
        console.error("Failed to load Forex history:", error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [username]);

  const formatMoney = (value) =>
    `$${Number(value || 0).toFixed(2)}`;

  const formatDate = (timestamp) => {
    if (!timestamp) return "--";

    const date = timestamp.toDate
      ? timestamp.toDate()
      : new Date(timestamp);

    return Number.isNaN(date.getTime())
      ? "--"
      : date.toLocaleString();
  };

  
return (
  <div className="forex-history-page">
    <ForexHeader />

    <header className="forex-history-header">
      <h1>Forex History</h1>
      <p>History of your Forex orders</p>
    </header>

    <main className="forex-history-content">
      {!username ? (
        <p>Please log in to view your history.</p>
      ) : loading ? (
        <p>Loading history...</p>
      ) : trades.length === 0 ? (
        <p>No Forex history found.</p>
      ) : (
        <div className="forex-history-table-wrapper">
          <div className="forex-history-table">
            <div className="forex-history-table-header">
            
              <span>Symbol</span>
              <span>Type</span>
              <span>Volume</span>
              <span>Open Price</span>
              <span>Close Price</span>
              <span>Profit / Loss</span>
              <span>Status</span>
              <span>Close Time</span>
            </div>

            {trades.map((trade) => {
              const profit = Number(
                trade.realisedProfitLoss ??
                trade.profitLoss ??
                0
              );

              return (
                <div
                  className="forex-history-table-row"
                  key={trade.id}
                >
                 
                  <span>{trade.symbol || "--"}</span>
                  <span>
                    {String(trade.side || "--").toUpperCase()}
                  </span>
                  <span>
                    {Number(trade.lots || 0).toFixed(2)}
                  </span>
                  <span>
                    {Number(
                      trade.openPrice ?? trade.entryPrice ?? 0
                    ).toFixed(5)}
                  </span>
                  <span>
                    {trade.closePrice == null
                      ? "--"
                      : Number(trade.closePrice).toFixed(5)}
                  </span>
                  <span
                    className={
                      profit >= 0
                        ? "history-profit"
                        : "history-loss"
                    }
                  >
                    {formatMoney(profit)}
                  </span>
                  <span>{trade.status || "--"}</span>
                  <span>
                    {formatDate(
                      trade.closedAt ||
                      trade.expiredAt ||
                      trade.createdAt
                    )}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </main>

    <ForexBottomNav />
  </div>
);

};
export default ForexHistory;